import { AfterViewInit, Component, ElementRef } from '@angular/core';

export type CustomCssPropertyValuePair = {
  cssProperty: string;
  cssValue: string;
};
export type CustomCssRule = {
  selector: string;
  rules: CustomCssPropertyValuePair[];
};

@Component({
  selector: 'app-dynamic-stylesheet',
  templateUrl: './dynamic-stylesheet.component.html',
  styleUrls: ['./dynamic-stylesheet.component.scss'],
})
export class DynamicStylesheetComponent implements AfterViewInit {
  dynamicStyleSheet?: CSSStyleSheet;

  constructor(private hostElement: ElementRef) {}

  ngAfterViewInit(): void {
    const dynamicStyleElement = document.createElement('style');
    this.hostElement.nativeElement.appendChild(dynamicStyleElement);
    this.dynamicStyleSheet = dynamicStyleElement.sheet as CSSStyleSheet;
  }

  upsertDynamicCssRule(customCssRule: CustomCssRule): void {
    if (this.dynamicStyleSheet?.insertRule) {
      const existingRuleIndex = Array.from(
        this.dynamicStyleSheet.cssRules,
      ).findIndex(
        // @ts-ignore
        (rule: CSSStyleRule) =>
          rule.selectorText && rule.selectorText === customCssRule.selector,
      );
      if (existingRuleIndex !== -1) {
        this.dynamicStyleSheet.removeRule(existingRuleIndex);
      }
      const propertyValuePairs = customCssRule.rules.map(
        (rule) => `${rule.cssProperty}: ${rule.cssValue};`,
      );
      this.dynamicStyleSheet.insertRule(
        customCssRule.selector + ' {' + propertyValuePairs.join(' ') + '}',
      );
    }
  }

  removeDynamicCssRule(selector: string): void {
    if (!this.dynamicStyleSheet) {
      return;
    }
    for (let i = 0; i < this.dynamicStyleSheet.cssRules.length; i++) {
      const rule = this.dynamicStyleSheet.cssRules[i] as CSSStyleRule;
      if (rule.selectorText === selector) {
        this.dynamicStyleSheet.removeRule(i);
      }
    }
  }
}
